module.exports = __webpack_public_path__ + "assets/intentionalPause.6fced52c.svg";